// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__ee9yP","unreadBadge":"styles_unreadBadge__3sh_o","modalContent":"styles_modalContent__pG0lo","modal":"styles_modal__NF0FR"};